import { render, staticRenderFns } from "./ScenarioBox.vue?vue&type=template&id=08df45a8"
import script from "./ScenarioBox.vue?vue&type=script&lang=js"
export * from "./ScenarioBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports